import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { PermissionsService } from 'src/app/shared/authorization/permissions.service';

@Injectable()
export class PermissionsGuard implements CanActivate {
  constructor(private _router: Router, private _permissionsService: PermissionsService) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Promise<boolean> {
    const permissions: string[] = next.data.permissions != null ? next.data.permissions : [];
    const hasPermission: boolean =
      permissions.find((p) => this._permissionsService.hasPermission(p)) != null;
    if (!hasPermission) {
      return this.redirect404();
    }
    return hasPermission;
  }

  public canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Promise<boolean> {
    return this.canActivate(route, state);
  }

  public async redirect404(): Promise<boolean> {
    await this._router.navigate(['/404']);
    return false;
  }
}
